<template>
  <div class="mini-remote" :class="{ hide: closed }">
    <div class="close" @click="closeRemote">
      <div class="close-icon">{{ closed ? '❮' : '✕' }}</div>
    </div>

    <div class="content">
      <div class="title">
        {{ $t('remote.title') }}
      </div>
      <div class="button" :class="{ active: distribution === 'LOCALISATION' }" @click="selectDistribution('LOCALISATION')">
        {{ $t('remote.localisation') }}
      </div>
      <div
        class="button"
        :class="{ active: distribution === 'TIME' }"
        @click="
          selectDistribution('TIME');
          selectAdvencedMode(false);
        "
      >
        {{ $t('remote.time') }}
      </div>
      <div
        class="button"
        :class="{ active: distribution === 'PERCENTAGE' }"
        @click="
          selectDistribution('PERCENTAGE');
          selectAdvencedMode(true);
        "
      >
        {{ $t('remote.timePercentage') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { useSignalR } from '@dreamonkey/vue-signalr';

export default {
  name: 'DistributionRemote',

  data() {
    return {
      closed: false,
      distribution: 'LOCALISATION',
      advencedMode: false,
    };
  },

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
    }),
  },

  created() {
    this.$socket = useSignalR();
  },

  mounted() {
    if (!this.isDesktop || this.$route.name === 'Controller') {
      this.$socket.invoke('action', { action: 'selectDistribution', parameters: this.distribution });
      this.$socket.invoke('action', { action: 'selectAdvencedMode', parameters: this.mode });
    }
  },

  methods: {
    closeRemote() {
      this.closed = !this.closed;
    },

    selectDistribution(distribution) {
      this.distribution = distribution;
      if (!this.isDesktop || this.$route.name === 'Controller') {
        this.$socket.invoke('action', { action: 'selectDistribution', parameters: distribution });
      }
    },

    selectAdvencedMode(mode) {
      this.advencedMode = mode;
      if (!this.isDesktop || this.$route.name === 'Controller') {
        this.$socket.invoke('action', { action: 'selectAdvencedMode', parameters: mode });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.mini-remote {
  position: fixed;
  bottom: 116px;
  right: 0;
  z-index: 1;
  transition: all 0.6s ease;

  &.hide {
    right: -250px;
  }

  .close {
    position: absolute;
    z-index: 10;
    top: 16px;
    left: -28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: colors.$red-color;
    width: 32px;
    height: 32px;
    border-radius: 4px 0 0 4px;
    color: colors.$white-color;
    font-size: 16px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
    cursor: pointer;

    .close-icon {
      transition: all 0.3s ease;
    }

    &:hover {
      left: -32px;

      .close-icon {
        transform: scale(1.2);
        opacity: 0.8;
      }
    }
  }

  .content {
    position: relative;
    z-index: 100;
    width: 256px;
    padding: 16px 12px;
    background: colors.$white-color;
    border-radius: 4px 0 0 4px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;

    .title {
      font-style: italic;
      margin: 0 0 16px 0;
    }

    .button {
      display: flex;
      align-items: center;
      width: 100%;
      height: 64px;
      padding: 4px 8px;
      margin: 12px 0;
      text-align: center;
      font-weight: bold;
      background: colors.$white-color;
      color: colors.$navy-color;
      border: solid 2px colors.$navy-color;
      border-radius: 4px;
      box-sizing: border-box;
      cursor: pointer;
      transition: all 0.3s ease;

      &:last-child {
        margin-bottom: 0;
      }

      &.active {
        background: colors.$navy-color;
        color: colors.$white-color;
        cursor: default;
      }

      &:hover:not(.active) {
        background: rgba(colors.$navy-color, 0.2);
      }

      &:not(.active):active {
        transform: scale(0.95);
        background: rgba(colors.$navy-color, 0.4);
      }
    }
  }
}
</style>
